import { z } from 'zod';

import { PasswordDto } from './user';

export const GenerateCorpCodesDto = z
  .object({
    count: z.coerce.number().int().min(1).max(1000),
  })
  .strict();

export type ApiGenerateCorpCodesDto = z.infer<typeof GenerateCorpCodesDto>;

export const QueryCorpCodesDto = z
  .object({
    search: z.string().trim().max(255).optional(),
    offset: z.coerce.number().int().min(1).default(1),
    limit: z.coerce.number().int().min(1).max(1000).default(25),
    orderBy: z.string().min(1).max(255).optional(),
    orderDirection: z.string().min(1).max(4).optional(),
    status: z
      .string()
      .toLowerCase()
      .pipe(z.enum(['used', 'unused', 'all']))
      .optional()
      .or(z.literal('')),
  })
  .strict();

export type ApiQueryCorpCodesDto = z.infer<typeof QueryCorpCodesDto>;

export const ChangeCorpPasswordDto = z
  .object({
    newPassword: PasswordDto,
    confirmPassword: z.string(),
  })
  .strict()
  .refine(
    ({ confirmPassword, newPassword }) => confirmPassword === newPassword,
    {
      message: 'VALIDATION__PasswordsMustMatch',
      path: ['confirmPassword'],
    },
  );

export type ApiChangeCorpPasswordDto = z.infer<typeof ChangeCorpPasswordDto>;

export const CorpCodeDto = z.object({
  id: z.string(),
  corpOrganizationId: z.string(),
  code: z.string(),
  isUsed: z.boolean(),
  usedByUserId: z.string().nullable(),
  usedAt: z.string().nullable(),
  createdAt: z.string(),
});

export type ApiCorpCodeDto = z.infer<typeof CorpCodeDto>;
